import { type DependencyList, useCallback } from 'react';
import { useBoolean } from 'usehooks-ts';

export function usePromiseCallback<P extends any[], R>(
  f: (...params: P) => Promise<R>,
  deps: DependencyList,
): [(...params: P) => Promise<R>, boolean] {
  const pending = useBoolean(false);

  const foo = useCallback(
    async function (...params: P) {
      try {
        pending.setTrue();
        const result = await f(...params);
        return result;
      } finally {
        pending.setFalse();
      }
    },
    [
      f,
      pending,
      // oxlint-disable-next-line react-hooks/exhaustive-deps
      ...deps,
    ],
  );

  return [foo, pending.value];
}
